import React, { useState } from 'react';
import { AuthHeader, Toast } from '@components/molecules';
import { Spinner, NonFieldErrorMessage, ErrorMessage } from '@components/atoms';
import Button from '@material-ui/core/Button';
import { Paper, Box, Container, TextField, Divider } from '@material-ui/core';
import UsuarioAPI from '@services/usuario';
import SaveIcon from '@material-ui/icons/Save';
import { Helmet } from 'react-helmet';
import { useForm } from 'react-hook-form';
import { Controller } from "react-hook-form";
import {useParams} from "react-router-dom";
import urls from '@urls';


export default function NovaSenhaPage({history}) {
    const { handleSubmit, control, setError, formState: { errors }, setValue} = useForm();
    const [loading, setLoading] = useState(false);
    const [toast, setToast] = useState(false);
    const [nonFieldErrorMessage, setNonFieldErrorMessage] = useState([]);  

    const { hash } = useParams();

    const onSubmit = async (data) => {
        setLoading(true);        
        data['hash'] = hash;

        await UsuarioAPI.newPassword(data).then(() => {
            setValue('new_password','');
            setValue('repeat_password','');
            setToast(true);
            setTimeout(function(){
                history.push(String(urls.acesso.login));
            }, 5000);
        }).catch((error) => {
            const data = error.response.data;
            if (data.non_field_errors) {
                setNonFieldErrorMessage(data.non_field_errors);
            }
            else{
                for (const [key, value] of Object.entries(data)) {
                    setError(key, {
                        type: "manual",
                        message: value[0],
                    });
                }                    
            }
        });
        setLoading(false);
    }

    return (
        <>  
            <Helmet>
                <title>Nova Senha</title>
            </Helmet>
            <Spinner open={loading} />
            <AuthHeader title="Informe uma nova senha" />
            <Container>
                <Paper elevation={0}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box p={3}>
                            <Controller
                                name={'new_password'}
                                control={control}
                                defaultValue=""
                                rules={{ required: true }}
                                render={({ field }) => {    
                                    return (                          
                                        <TextField
                                            label="Nova Senha"
                                            type="password"
                                            margin="normal"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error={errors["password"]}
                                            {...field}
                                        />
                                    )
                                }}
                            />
                            <ErrorMessage error={errors['new_password']} />
                            <Controller
                                name={'repeat_password'}
                                control={control}
                                defaultValue=""
                                rules={{ required: true }}
                                render={({ field }) => {    
                                    return (                               
                                        <TextField
                                            label="Confirmar Senha"
                                            type="password"
                                            margin="normal"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error={errors["repeat_password"]}
                                            {...field}
                                        />
                                    )
                                }}
                            />
                            <ErrorMessage error={errors['repeat_password']} />
                        </Box>
                        <NonFieldErrorMessage non_field_errors={nonFieldErrorMessage} />  
                        <Divider />
                        <Box p={3}>
                            <Button startIcon={<SaveIcon />} type="submit" color="green">
                                Confirmar
                            </Button>
                        </Box>
                    </form>
                </Paper>
            </Container>
            <Toast
                open={toast}
                handleClose={() => setToast(false)}
                severity="success"
                duration={6000}
            >
                Senha alterada com sucesso, você será redirecionado para tela de login!
            </Toast>

        </>
    )
}
